import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Loader } from 'rsuite';
import {
  cancelPostAction,
  getCampaignElementById,
  getCampaignId,
  getIpAddress,
  getShouldShowPostRecordingActions,
  getVideoPreview,
  selectVideo,
  showCameraRecorder,
  setSelectedVideoFile,
  getIsUploadingVideo
} from '../../redux/modules/campaignLandingPage';
import { getFileSizeLabel } from '../../utils';

import styles from './PostRecordingActions.module.less';
import './fadeInAnimation.less';

const mimeTypeToExtensionMap = {
  'video/mp4': 'mp4',
  'video/quicktime': 'mov',
  'video/x-webm': 'mkv',
  'video/avi': 'avi',
  'video/x-msvideo': 'avi',
  'video/webm': 'webm',
  'video/divx': 'divx',
  'video/mpeg': 'mpeg',
  'video/mpeg2': 'm2v',
  'video/x-ms-wmv': 'wmv',
  'video/3gpp': 'tgp',
  'video/mp2p': 'mpeg2',
  'video/ogg': 'ogv',
  'video/x-flv': 'flv'
};

const PostRecordingActions = ({
  _cancelPostAction,
  _selectVideo,
  _showCameraRecorder,
  _setSelectedVideoFile,
  qid,
  shouldShowPostRecordingActions,
  userIpAddress,
  isUploadingVideo,
  videoPreview,
  campaignId,
  createMediaSubmissionFn
}) => {
  if (!shouldShowPostRecordingActions) {
    return null;
  }

  const actionsRef = useRef(null);

  // Create local state for file reference
  const [file, setFile] = useState(null);

  useEffect(() => {
    // Get a file reference from the blob URL
    // the first time the component renders
    const fileFromBlobUrl = async () => {
      const file = await fetch(videoPreview).then((r) => r.blob());
      const ext = mimeTypeToExtensionMap[file.type] || 'mp4';
      file.name = `recorded-video.${ext}`;

      // Store file ref in local state
      setFile(file);

      // Fade in
      actionsRef.current.classList.add('vpFadeIn');

      // dispatch
      _setSelectedVideoFile(qid, file);

      return file;
    };

    fileFromBlobUrl();
  }, []);

  const handleSave = () => {
    const mediaSubmission = {
      isRecorded: true,
      userAgent: navigator.userAgent,
      userIp: userIpAddress,
      screenResolution: `${window.outerWidth}x${window.outerHeight}`,
      mimeType: file.type,
      campaignId,
      fileSize: getFileSizeLabel(file.size) 
    };

    // Create media submission, which will trigger file upload
    // on the parent container
    createMediaSubmissionFn({ data: mediaSubmission });
  };

  const handleReRecord = () => {
    // null out existing blob url
    _selectVideo(qid, null);
    _showCameraRecorder(qid);
  };

  const handleCancel = () => {
    _selectVideo(qid, null);
    _cancelPostAction(qid);
  };

  return (
    <section className={styles.vpPostRecordingActionsSection} ref={actionsRef}>
      {isUploadingVideo ? (
        <Loader size="md" />
      ) : (
        <>
          <div className={styles.vpPostRecordingActionButton} onClick={handleCancel}>
            <Icon icon="close" />
            <div>Cancel</div>
          </div>
          <div className={styles.vpPostRecordingActionButton} onClick={handleReRecord}>
            <Icon icon="refresh" />
            <div>Redo Recording</div>
          </div>
          <div className={styles.vpPostRecordingActionButton} onClick={handleSave}>
            <Icon icon="thumbs-up" />
            <div>Looks Good</div>
          </div>
        </>
      )}
    </section>
  );
};

PostRecordingActions.propTypes = {
  _cancelPostAction: PropTypes.func,
  _selectVideo: PropTypes.func,
  _showCameraRecorder: PropTypes.func,
  _setSelectedVideoFile: PropTypes.func,
  campaignElement: PropTypes.object,
  shouldShowPostRecordingActions: PropTypes.bool,
  userIpAddress: PropTypes.string,
  isUploadingVideo: PropTypes.bool,
  videoPreview: PropTypes.string,
  campaignId: PropTypes.number,
  qid: PropTypes.string
};

function mapStateToProps(state, ownProps) {
  return {
    campaignElement: getCampaignElementById(state, ownProps.qid),
    shouldShowPostRecordingActions: getShouldShowPostRecordingActions(state, ownProps.qid),
    userIpAddress: getIpAddress(state),
    isUploadingVideo: getIsUploadingVideo(state, ownProps.qid),
    videoPreview: getVideoPreview(state, ownProps.qid),
    campaignId: getCampaignId(state),
  };
}

const mapDispatchToProps = {
  _cancelPostAction: cancelPostAction,
  _selectVideo: selectVideo,
  _showCameraRecorder: showCameraRecorder,
  _setSelectedVideoFile: setSelectedVideoFile
};

export default connect(mapStateToProps, mapDispatchToProps)(PostRecordingActions);



// WEBPACK FOOTER //
// ./src/components/CampaignLanding/PostRecordingActions.jsx